import {
	devLog,
} from 'core/utils';


const identifyWhenLoaded = (uniqueId) => {
	// Wait for heap to finish initializing. If the user hasn't already been identified in
	// this session, then identify the user.
	if (! window || ! window.setInterval) {
		return;
	}
	let heapUser = window.heap.userId;
	const waitForLoad = setInterval(function() {
		if (heapUser === undefined) {
			devLog("heap user data not loaded, skipping until user found");
		}
		if (! window.heap.userId) {
			heapUser = false;
			return;
		} else {
			clearInterval(waitForLoad);
			if (! window.heap.identity || window.heap.identity !== uniqueId) {
				devLog("heap identifying user");
				window.heap.identify(uniqueId);
			} else {
				devLog("user already identified in heap, skipping identify call");
			}
		}

	}, 100);
};


export const identify = () => {
	if (! window || ! window.heap) return;
	const user = window?.cj?.user;
	const id = user?.id;
	if (! id) return;

	identifyWhenLoaded(`${id}`);
};

export const track = (eventName, eventProps) => {
	if (! window || ! window.heap) return;

	window.heap.track(eventName, eventProps);
};

const HeapUtil = {
	identify,
	track,
};

export default HeapUtil;
